module.exports = __webpack_public_path__ + "img/icon_weather_409.8b598214.svg";